import React from "react";
import { Link } from "react-router-dom";
import Image from "@theme/assets/rob.png";
import FourZeroFourStyleWrapper from "./404.styles";
export const NotFound = () => {
  return (
    <FourZeroFourStyleWrapper className="iso404Page">
      <main className="iso404Content" data-testid="not-found-page">
        <h1>404 Page Not Found</h1>
        <h3>Looks like you got lost</h3>
        <p>The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/">
          <button type="button">BACK HOME</button>
        </Link>
      </main>
      <div className="iso404Artwork">
        <img alt="#" src={Image} />
      </div>
    </FourZeroFourStyleWrapper>
  );
}

export default NotFound;